package es.subastia.domain.usecase

import es.subastia.domain.model.AuctionDomainModel
import es.subastia.domain.repository.FavoritesRepository
import kotlinx.coroutines.flow.Flow

class GetFavoritesUseCase(private val repository: FavoritesRepository) {
    operator fun invoke(userId: String): Flow<List<AuctionDomainModel>> = repository.getFavorites(userId)
}

class IsFavoriteUseCase(private val repository: FavoritesRepository) {
    operator fun invoke(userId: String, auctionId: String): Flow<Boolean> = repository.isFavorite(userId, auctionId)
}

class ToggleFavoriteUseCase(private val repository: FavoritesRepository) {
    suspend operator fun invoke(userId: String, auctionId: String) = repository.toggleFavorite(userId, auctionId)
}
